<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.0492 10.6768C18.0825 10.66 18.1327 10.6516 18.1742 10.6768C18.2466 10.7179 18.2493 10.8149 18.2493 10.8203L18.182 15.124C18.1818 16.8959 16.7646 18.3299 15.014 18.3301H4.97591C3.22513 18.3301 1.80712 16.896 1.80697 15.124L1.74935 10.8203C1.74942 10.8148 1.75167 10.7177 1.82454 10.6768C1.89115 10.6352 1.97443 10.6849 1.98275 10.6934C3.66686 11.824 5.69275 12.5755 7.81869 12.8877C8.11874 12.9297 8.41893 12.7353 8.50228 12.4316C8.68582 11.7399 9.2781 11.2842 9.98665 11.2842H10.0111C10.7195 11.2843 11.312 11.7399 11.4954 12.4316C11.5788 12.7354 11.879 12.9298 12.179 12.8877C14.305 12.5754 16.3319 11.8241 18.016 10.6934C18.0193 10.6917 18.0345 10.6842 18.0492 10.6768ZM9.99447 12.4902C9.65299 12.4904 9.36983 12.7775 9.36947 13.123V14.2119C9.36947 14.5662 9.65277 14.8446 9.99447 14.8447C10.3445 14.8446 10.6204 14.5662 10.6204 14.2119V13.123C10.6201 12.7775 10.3443 12.4904 9.99447 12.4902ZM11.0706 1.66406C12.3212 1.66419 13.3468 2.61825 13.5052 3.8418H15.1556C16.9064 3.8418 18.3323 5.28455 18.3324 7.05664C18.3324 7.05664 18.2826 7.80691 18.266 8.85156C18.2643 8.93417 18.2243 9.01549 18.1585 9.06445C17.7575 9.36065 17.3901 9.60519 17.3568 9.62207C15.9728 10.5503 14.3641 11.2034 12.6507 11.5283C12.5391 11.55 12.429 11.492 12.3724 11.3926C11.8921 10.5606 10.9949 10.0186 9.99447 10.0186C9.00079 10.0187 8.09526 10.5549 7.60091 11.3877C7.54337 11.4854 7.43531 11.5415 7.32454 11.5205C5.62536 11.1948 4.01664 10.5431 2.64095 9.63086L1.84115 9.07324C1.77445 9.03105 1.73275 8.95548 1.73275 8.87109C1.70774 8.44072 1.66537 7.05664 1.66537 7.05664C1.66543 5.28461 3.09136 3.84188 4.84212 3.8418H6.4847C6.64311 2.61819 7.66867 1.66409 8.91927 1.66406H11.0706ZM8.91927 2.93066C8.3607 2.93071 7.88567 3.31862 7.75228 3.8418H12.2376C12.1042 3.31865 11.6292 2.93076 11.0706 2.93066H8.91927Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
